import { AssetDto } from '@nusign/picflow-backend-types';
import { Rect } from '../../classes/rect.class';
import { assetSideMenuSize } from '../../consts';

export const calcContainerSizeForAsset = (
  asset: AssetDto,
  windowWidth: number,
  windowHeight: number,
  sideMenuOpen: boolean
) => {
  const extraVerticalSpace = asset?.type === 'video' ? 120 : 0;

  const isDesktop = windowWidth > 900;
  if (!isDesktop) {
    return new Rect(0, 0, windowWidth, sideMenuOpen ? windowHeight * 0.3 : windowHeight - extraVerticalSpace);
  }

  return new Rect(
    0,
    0,
    windowWidth - (sideMenuOpen ? assetSideMenuSize : 0) - (asset?.type === 'document' ? 160 : 0),
    windowHeight - extraVerticalSpace
  );
};
